import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ClientService } from '../../services/client.service';
import { Client } from '../../models'

import { Router } from '@angular/router';
@Component({
  selector: 'smr-client-sales',
  templateUrl: './client-sales.component.html',
  styleUrls: ['./client-sales.component.scss'],
})
export class ClientSalesComponent implements OnInit, OnChanges {

  @Input() client: Client
  public sales

  subscriptions;
  constructor(
    private clientService: ClientService,
    private router: Router
  ) { }

  ngOnInit() {
    this.fetchClientSales()
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.client) {
      this.fetchClientSales()
    }
  }

  private fetchClientSales () {
    this.subscriptions = this.clientService.getClientSales(this.client).subscribe((data)=>{
      this.sales = data
    })

  }

  navigate(saleId) {
    this.router.navigateByUrl('/sales/sale-receipt/'+  saleId)
  }
}
